import React from 'react';
import { type DialogProps } from '@economic/taco';

import { paymentCardsApi } from '~/app/pages/accounting/payment-cards/api';
import { usePaymentCardsOnboardingDialogContextBuilder } from './useContextBuilder';
import { PaymentCardsOnboardingDialogContext } from './Context';
import PaymentCardsOnboardingDialogComponent from './DialogComponent';

interface PaymentCardsOnboardingDialogProviderProps extends Partial<DialogProps> {
    agreementNumber: number;
    walletUrl: string;
    onCloseDialog?: () => void;
}

const PaymentCardsOnboardingDialogProvider = ({
    agreementNumber,
    walletUrl,
    onCloseDialog,
    ...dialogProps
}: PaymentCardsOnboardingDialogProviderProps) => {
    const [isOpen, setIsOpen] = React.useState(dialogProps.open ?? dialogProps.defaultOpen);
    const contextValue = usePaymentCardsOnboardingDialogContextBuilder({
        api: paymentCardsApi,
        agreementNumber,
        walletUrl,
        onCloseDialog: () => {
            setIsOpen(false);
            dialogProps.onClose?.();
            onCloseDialog?.();
        },
    });

    // in case we want controll outside of the dialog
    React.useEffect(() => {
        setIsOpen(dialogProps.open);
    }, [dialogProps.open]);

    return (
        <PaymentCardsOnboardingDialogContext.Provider value={contextValue}>
            <PaymentCardsOnboardingDialogComponent {...dialogProps} open={isOpen} />
        </PaymentCardsOnboardingDialogContext.Provider>
    );
};

export default PaymentCardsOnboardingDialogProvider;
